import { ConfirmModal } from './confirm-modal';

export default ConfirmModal;
